export enum BudgetingType {
    BUDGET = "budget",
    REFORECAST = "reforecast"
}